<script setup lang="ts">
import type { PropType } from 'vue';

import { type AuctionItemEntity, type AuctionListingItemEntity, AuctionState } from '~/apiClient';

const { auction } = defineProps({
    auction: { type: Object as PropType<AuctionListingItemEntity | AuctionItemEntity>, required: true },
    labelClass: { type: String, default: undefined },
    countdownClass: { type: String, default: undefined },
});

const { tt } = useTypedI18n();

const isPending = computed(() => auction.state === AuctionState.Pending);

const countDownExpiresAt = computed(() => (isPending.value ? auction.startAt : auction.expiresAt));

const { totalSeconds } = useCountdown(countDownExpiresAt);

const textColor = computed(() => (auction.state === AuctionState.Running && totalSeconds.value < 60 * 15 ? 'text-warning-500' : 'text-primary'));
</script>

<template>
    <span v-if="totalSeconds > 0">
        <span :class="labelClass">{{ tt(isPending ? 'countdown.startsIn' : 'countdown.endsIn') }}:&nbsp;</span>
        <BaseCountdown v-if="countDownExpiresAt" :class="[textColor, countdownClass]" :expires-at="countDownExpiresAt" />
    </span>
</template>
